import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PdfBillingComponent } from './pdf-billing.component';


@NgModule({
  declarations: [
    PdfBillingComponent
  ],
  exports: [
    PdfBillingComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  providers: []
})
export class PdfBillingModule { }
